const translations = {
  title: 'Sending Form',
  subtitle: 'Fill the fields below to send the form',
  form: 'Form',
  placeField: 'Email field',
  'guide.title': 'Select the locales you want to send the form: ',
  'guide.title_person': 'Select the people you want to send the form: ',
  'guide.title_fleet': 'Select the fleets you want to send the form: ',
  'guide.help': 'Need help? Click here to begin the tour'
}

export default translations
